import React, { useEffect, useState } from "react";
import { getGoals, updateGoal, generateGoal } from "@/lib/api";
import { PageHeader, StatusChip } from "@/components/dashboard/ui";
import { Sparkles, Check } from "lucide-react";
import { toast } from "sonner";

export default function TreatmentPlans() {
  const [goals, setGoals] = useState([]);
  const [tab, setTab] = useState("Goals");
  useEffect(() => { getGoals().then(setGoals); }, []);
  const toggle = async (g) => {
    const done = !g.done; setGoals((p) => p.map((x) => x.id === g.id ? { ...x, done } : x));
    try { await updateGoal(g.id, { done, status: done ? "On Track" : g.status }); } catch {}
  };
  const gen = async () => { try { const g = await generateGoal(); setGoals((p) => [...p, g]); toast.success("AI added a new goal"); } catch { toast.error("Failed"); } };
  return (
    <div className="fade-in max-w-4xl">
      <PageHeader title="AI-Assisted Treatment Planner" subtitle="Individualized care plan for Noah Smith" action={<button data-testid="tp-generate" onClick={gen} className="btn-primary px-5 py-2.5 font-semibold inline-flex items-center gap-2"><Sparkles size={18} /> Generate with AI</button>} />
      <div className="card-soft p-5">
        <div className="flex gap-1 border-b border-slate-100 mb-4 overflow-x-auto">{["Goals", "Interventions", "Home Activities", "School Goals", "Routines"].map((t) => (<button key={t} onClick={() => setTab(t)} className={`px-3 py-2 text-[14px] font-semibold whitespace-nowrap border-b-2 -mb-px ${tab === t ? "border-[#1a5fd0] text-[#1a5fd0]" : "border-transparent text-slate-400 hover:text-slate-600"}`}>{t}</button>))}</div>
        <ul className="space-y-3">
          {goals.map((g) => (
            <li key={g.id} className="flex items-start gap-3.5 p-3 rounded-2xl hover:bg-[#f6f9fe]">
              <button onClick={() => toggle(g)} data-testid={`tp-goal-${g.id}`} className={`mt-0.5 h-6 w-6 rounded-lg grid place-items-center border ${g.done ? "bg-[#1a5fd0] border-[#1a5fd0] text-white" : "border-slate-300 text-transparent hover:border-[#1a5fd0]"}`}><Check size={15} /></button>
              <div className="flex-1"><div className="text-[15px] font-bold text-[#10233f]">{g.title}</div><div className="text-[13.5px] text-slate-500">{g.detail}</div></div>
              <StatusChip status={g.status} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
